import React from "react";
import AllReview from "../../components/Review/AllReview";
import MainWrapper from "../../Wrapper/MainWrapper";
import { reviewRefrencePageArr } from "../../components/Review/AllReview";
import AboutUs from "../../components/About-us/AboutUs";

const Page =()=>{
    return <>
    <MainWrapper refrence={'about'}>
        
        <AboutUs />
    </MainWrapper>
    </>
}

export default Page;